// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.rDNA-generalInfo .rDNA-webDomain {
  font-family: "Dm Sans", sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
}

.rDNA-generalInfo .img-constrainer, .rDNA-generalInfo .rDNA-socialsBox, .rDNA-generalInfo {
  display: flex;
  flex-direction: column;
}

.rDNA-generalInfo .rDNA-webDomain {
  display: flex;
  flex-direction: row;
}

.rDNA-generalInfo .rDNA-webDomain, .rDNA-generalInfo .img-constrainer, .rDNA-generalInfo .img-tile, .rDNA-generalInfo .rDNA-socialsBox {
  justify-content: center;
  align-items: center;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.rDNA-generalInfo {
  justify-content: space-between;
  height: 100%;
  width: 100%;
}
.rDNA-generalInfo .rDNA-socialBar {
  width: 100%;
}
.rDNA-generalInfo .rDNA-socialsBox {
  flex: 1;
}
.rDNA-generalInfo .rDNA-companyLogo {
  position: relative !important;
}
.rDNA-generalInfo .img-tile {
  background: #fff;
  border-radius: 25px;
  display: flex;
  flex: 6;
  position: relative; /* Ensure the overlay is positioned relative to this container */
  height: 200px; /* Set a fixed height or adjust as needed */
}
.rDNA-generalInfo .rDNA-companyLink {
  color: #1B3E78;
}
.rDNA-generalInfo .rDNA-companyLink:hover {
  color: #A3AED0;
}
.rDNA-generalInfo .img-constrainer {
  width: 100%;
  border-radius: 25px;
  background: #fff;
}
.rDNA-generalInfo .rDNA-webDomain {
  flex: 1;
  box-shadow: none;
  border-radius: 10px;
  margin: 0;
  height: 20px;
}

@media screen and (max-width: 1023.7px) and (min-width: 768px) {
  .rDNA-generalInfo .img-constrainer {
    max-width: 200px;
    max-height: 200px;
  }
  .rDNA-generalInfo .rDNA-socialBar {
    padding-bottom: 10px;
  }
  .rDNA-generalInfo .rDNA-socialsBox {
    padding: 0 5px;
    margin: 5px 0 0;
  }
  .rDNA-generalInfo .rDNA-webDomain {
    font-size: 10px;
    margin: 5px 0 0;
  }
}
@media screen and (max-width: 1199.7px) and (min-width: 1024px) {
  .rDNA-generalInfo .img-constrainer {
    max-width: 250px;
    max-height: 200px;
  }
  .rDNA-generalInfo .rDNA-socialBar {
    padding-bottom: 20px;
  }
  .rDNA-generalInfo .rDNA-companyLogo {
    max-height: 200px;
    width: auto;
    object-fit: contain;
  }
  .rDNA-generalInfo .rDNA-socialsBox {
    padding: 0 15px;
    margin: 10px 0 0;
  }
  .rDNA-generalInfo .rDNA-webDomain {
    font-size: 12px;
    margin: 10px 0 0;
  }
  .rDNA-generalInfo .rDNA-companyLogo {
    max-height: 200px;
    width: auto;
    object-fit: contain;
  }
}
@media screen and (max-width: 1439.7px) and (min-width: 1200px) {
  .rDNA-generalInfo .img-constrainer {
    max-height: 200px;
    width: auto;
    object-fit: contain;
  }
}
@media screen and (max-width: 2559.7px) and (min-width: 1199.7px) {
  .rDNA-generalInfo .img-constrainer {
    max-width: 250px;
    max-height: 250px;
  }
  .rDNA-generalInfo .rDNA-socialBar {
    padding-bottom: 10px;
  }
  .rDNA-generalInfo .rDNA-companyLogo {
    max-height: 200px;
    width: auto;
    object-fit: contain;
  }
  .rDNA-generalInfo .rDNA-socialsBox {
    padding: 0 15px;
    margin: 10px 0 0;
  }
  .rDNA-generalInfo .rDNA-webDomain {
    font-size: 14px;
    margin: 10px 0 0;
  }
}
@media screen and (min-width: 2560px) {
  .rDNA-generalInfo .img-constrainer {
    max-width: 325px;
  }
  .rDNA-generalInfo .rDNA-webDomain {
    font-size: 22px;
  }
  .rDNA-generalInfo .rDNA-socialsBox {
    padding: 0 15px;
    margin: 10px 0 0;
  }
  .rDNA-generalInfo .img-tile {
    margin: 0 0 20px 0;
  }
}
.socials-overlay {
  position: relative; /* Ensure the overlay is positioned relative to this container */
  width: 100%; /* Ensure it takes full width */
  height: auto; /* Adjust height as needed */
}

.logo-container {
  width: 100%; /* Ensure it takes full width */
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/theme/fonts.scss","webpack://./src/app/profiles/dashboard/elements/company-general-info/company-general-info.component.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/placeholders/_fonts.scss","webpack://./src/theme/mixins.scss","webpack://./src/theme/placeholders/_flexboxes.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACCF;ADEA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ACAF;ADGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACDF;ADIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ACFF;ADKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACHF;ADMA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ACJF;ADOA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACLF;ADQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACNF;ADSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACPF;ADUA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACRF;ADWA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ACTF;ADYA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACVF;ADaA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ACXF;ADcA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ACZF;ADeA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACbF;ADgBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACdF;ADiBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ACfF;ADkBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AChBF;ACpGA;;;;;uBAAA;ACmCA;EC1BE,kCFXY;EEYZ,eDyB2C;ECxB3C,gBAXqF;EAYrF,kBALgB;AHyGlB;;AItHA;EAC0B,aAAA;EACA,sBAAA;AJyH1B;;AItHA;EAC0B,aAAA;EACA,mBAAA;AJyH1B;;AItHA;EAC0B,uBAAA;EACA,mBAAA;AJyH1B;;ADtIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACyIF;ADtIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ACwIF;ADrIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACuIF;ADpIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ACsIF;ADnIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACqIF;ADlIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ACoIF;ADjIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACmIF;ADhIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACkIF;AD/HA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACiIF;AD9HA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACgIF;AD7HA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AC+HF;AD5HA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AC8HF;AD3HA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AC6HF;AD1HA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AC4HF;ADzHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AC2HF;ADxHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AC0HF;ADvHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ACyHF;ADtHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACwHF;AC5OA;;;;;uBAAA;ADCA;EAEgC,8BAAA;EACA,YAAA;EACA,WAAA;AAkPhC;AAhPE;EAAgC,WAAA;AAmPlC;AAlPE;EACgC,OAAA;AAoPlC;AAhPE;EACgC,6BAAA;AAkPlC;AA/OE;EACgC,gBCTrB;EDUqB,mBApBd;EAqBc,aAAA;EACA,OAAA;EAEA,kBAAA,EAAA,gEAAA;EACA,aAAA,EAAA,2CAAA;AAgPlC;AA9OE;EACgC,cCnBtB;ADmQZ;AA/OkC;EAAU,cClB5B;ADoQhB;AAhPE;EAGgC,WAAA;EACA,mBAnCd;EAoCc,gBAAA;AAgPlC;AA9OE;EACgC,OAAA;EACA,gBAAA;EAEA,mBAAA;EACA,SAAA;EACA,YAAA;AA+OlC;;AA1OA;EAEE;IAAiC,gBADlB;IAC4C,iBAD5C;EA+Of;EA3OE;IAAgC,oBAAA;EA8OlC;EA5OE;IACgC,cAAA;IACA,eAAA;EA8OlC;EA5OE;IAEgC,eAAA;IACA,eAAA;EA6OlC;AACF;AA1OA;EAEE;IAAiC,gBADlB;IAC4C,iBAAA;EA6O3D;EA1OE;IAAgC,oBAAA;EA6OlC;EA3OE;IACE,iBAAA;IACA,WAAA;IACA,mBAAA;EA6OJ;EA3OE;IACgC,eAAA;IACA,gBAAA;EA6OlC;EA3OE;IAEgC,eAAA;IACA,gBAAA;EA4OlC;EA1OE;IACgC,iBAAA;IACA,WAAA;IACA,mBAAA;EA4OlC;AACF;AAxOA;EAEI;IACkC,iBAAA;IACA,WAAA;IACA,mBAAA;EAyOpC;AACF;AArOA;EAEE;IAAkC,gBADnB;IAC6C,iBAD7C;EAyOf;EArOE;IAAgC,oBAAA;EAwOlC;EAtOE;IACgC,iBAAA;IACA,WAAA;IACA,mBAAA;EAwOlC;EAtOE;IACgC,eAAA;IACA,gBAAA;EAwOlC;EAtOE;IACgC,eAAA;IACA,gBAAA;EAwOlC;AACF;AApOA;EAEI;IAA+B,gBAAA;EAsOjC;EArOE;IACgC,eAAA;EAuOlC;EArOE;IACgC,eAAA;IACA,gBAAA;EAuOlC;EArOE;IAAgC,kBAAA;EAwOlC;AACF;AArOA;EACE,kBAAA,EAAA,gEAAA;EACA,WAAA,EAAA,+BAAA;EACA,YAAA,EAAA,4BAAA;AAuOF;;AApOA;EACE,WAAA,EAAA,+BAAA;EACA,YAAA;AAuOF","sourcesContent":["@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import 'placeholders/fonts';\n@import 'placeholders/flexboxes';\n@import 'placeholders/quickStyles';\n@import 'variables/breakpoints';\n@import 'variables';\n\n$img-border-radius: 25px;\n\n.rDNA-generalInfo             {\n                                @extend %flex-column;\n                                justify-content: space-between;\n                                height: 100%;\n                                width: 100%;\n\n  .rDNA-socialBar               { width: 100%; }\n  .rDNA-socialsBox              {\n                                  flex: 1;\n                                  @extend %flex-column;\n                                  @extend %flex-jCenter-aCenter;\n                                }\n  .rDNA-companyLogo             {\n                                  position: relative !important;\n                                  //border-radius: $img-border-radius;\n                                }\n  .img-tile                     {\n                                  background: $light-text;\n                                  border-radius: $img-border-radius;\n                                  display: flex;\n                                  flex: 6;\n                                  @extend %flex-jCenter-aCenter;\n                                  position: relative; /* Ensure the overlay is positioned relative to this container */\n                                  height: 200px; /* Set a fixed height or adjust as needed */\n                                }\n  .rDNA-companyLink             {\n                                  color: $dark-text;\n                                  &:hover { color: $inactive-text; }\n                                }\n  .img-constrainer              {\n                                  @extend %flex-column;\n                                  @extend %flex-jCenter-aCenter;\n                                  width: 100%;\n                                  border-radius: $img-border-radius;\n                                  background: #fff;\n                                }\n  .rDNA-webDomain               {\n                                  flex: 1;\n                                  box-shadow: none;\n                                  @extend %font-12px-medium;\n                                  border-radius: 10px;\n                                  margin: 0;\n                                  height: 20px;\n                                  @extend %flex-row;\n                                  @extend %flex-jCenter-aCenter;\n                                }\n}\n@media screen and ( max-width: $breakpoint-md-max) and (min-width: $breakpoint-md-min) {\n  $image-sizing: 200px;\n  %image-dimensions-md           { max-width: $image-sizing; max-height: $image-sizing; }\n\n  .rDNA-generalInfo             {\n    .rDNA-socialBar               { padding-bottom: 10px; }\n    .img-constrainer              { @extend %image-dimensions-md; }\n    .rDNA-socialsBox              {\n                                    padding: 0 5px;\n                                    margin: 5px 0 0;\n                                  }\n    .rDNA-webDomain               {\n                                    //height: 30px;\n                                    font-size: 10px;\n                                    margin: 5px 0 0;\n                                  }\n  }\n}\n@media screen and ( max-width: $breakpoint-lg-max) and (min-width: $breakpoint-lg-min) {\n  $image-sizing: 250px;\n  %image-dimensions-lg           { max-width: $image-sizing; max-height: 200px; }\n\n  .rDNA-generalInfo             {\n    .rDNA-socialBar               { padding-bottom: 20px; }\n    .img-constrainer              { @extend %image-dimensions-lg; }\n    .rDNA-companyLogo {\n      max-height: 200px;\n      width: auto;\n      object-fit: contain;\n    }\n    .rDNA-socialsBox              {\n                                    padding: 0 15px;\n                                    margin: 10px 0 0;\n                                  }\n    .rDNA-webDomain               {\n                                    //height: 40px;\n                                    font-size: 12px;\n                                    margin: 10px 0 0;\n                                  }\n    .rDNA-companyLogo {\n                                    max-height: 200px;\n                                    width: auto;\n                                    object-fit: contain;\n                                  }\n  }\n}\n\n@media screen and (max-width: $breakpoint-xl-max) and (min-width: $breakpoint-xl-min) {\n  .rDNA-generalInfo{\n    .img-constrainer                {\n                                      max-height: 200px;\n                                      width: auto;\n                                      object-fit: contain;\n                                    }\n    }\n}\n\n@media screen and ( max-width: $breakpoint-xxl-max) and (min-width: $breakpoint-lg-max) {\n  $image-sizing: 250px;\n  %image-dimensions-xxl           { max-width: $image-sizing; max-height: $image-sizing; }\n\n  .rDNA-generalInfo             {\n    .rDNA-socialBar               { padding-bottom: 10px; }\n    .img-constrainer              { @extend %image-dimensions-xxl; }\n    .rDNA-companyLogo             {\n                                    max-height: 200px;\n                                    width: auto;\n                                    object-fit: contain;\n                                  }\n    .rDNA-socialsBox              {\n                                    padding: 0 15px;\n                                    margin: 10px 0 0;\n                                  }\n    .rDNA-webDomain               {\n                                    font-size: 14px;\n                                    margin: 10px 0 0;\n                                  }\n  }\n}\n\n@media screen and (min-width: $breakpoint-xxxl-min) {\n  .rDNA-generalInfo             {\n    .img-constrainer             { max-width: 325px; }\n    .rDNA-webDomain               {\n                                    font-size: 22px;\n                                  }\n    .rDNA-socialsBox              {\n                                    padding: 0 15px;\n                                    margin: 10px 0 0;\n                                  }\n    .img-tile                     { margin: 0 0 20px 0; }\n  }\n}\n\n.socials-overlay {\n  position: relative; /* Ensure the overlay is positioned relative to this container */\n  width: 100%; /* Ensure it takes full width */\n  height: auto; /* Adjust height as needed */\n}\n\n.logo-container {\n  width: 100%; /* Ensure it takes full width */\n  height: auto;\n}\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n","@import '../mixins';\n\n/////////////////////////////////////\n//   Extra Bold Font Placeholders  //\n/////////////////////////////////////\n\n%font-16px-extra-bold { @include format-font(16px, 'extra bold'); }\n\n/////////////////////////////////////\n//     Bold Font Placeholders     //\n/////////////////////////////////////\n\n%font-52px-bold       { @include format-font(52px, 'bold'); }\n%font-48px-bold       { @include format-font(48px, 'bold'); }\n%font-34px-bold       { @include format-font(34px, 'bold'); }\n%font-32px-bold       { @include format-font(32px, 'bold'); }\n%font-28px-bold       { @include format-font(28px, 'bold'); }\n%font-24px-bold       { @include format-font(24px, 'bold'); }\n%font-20px-bold       { @include format-font(20px, 'bold'); }\n%font-18px-bold       { @include format-font(18px, 'bold'); }\n%font-16px-bold       { @include format-font(16px, 'bold'); }\n%font-14px-bold       { @include format-font(14px, 'bold'); }\n%font-12px-bold       { @include format-font(12px, 'bold'); }\n\n\n/////////////////////////////////////\n//   Semi-Bold Font Placeholders   //\n/////////////////////////////////////\n\n%font-24px-semi       { @include format-font(24px, 'semi-bold'); }\n%font-20px-semi       { @include format-font(20px, 'semi-bold'); }\n\n\n/////////////////////////////////////\n//     Medium Font Placeholders    //\n/////////////////////////////////////\n\n%font-30px-medium     { @include format-font(30px, 'medium'); }\n%font-20px-medium     { @include format-font(20px, 'medium'); }\n%font-18px-medium     { @include format-font(18px, 'medium'); }\n%font-16px-medium     { @include format-font(16px, 'medium'); }\n%font-14px-medium     { @include format-font(14px, 'medium'); }\n%font-12px-medium     { @include format-font(12px, 'medium'); }\n%font-10px-medium     { @include format-font(10px, 'medium'); }\n\n/////////////////////////////////////\n//    Normal Font Placeholders     //\n/////////////////////////////////////\n\n%font-18px-normal     { @include format-font(18px); }\n%font-16px-normal     { @include format-font(16px); }\n%font-14px-normal     { @include format-font(14px); }\n%font-12px-normal     { @include format-font(12px); }\n","@import 'variables';\n\n@mixin format-font($size, $weight: 500, $style: 'normal' ) {\n  @if ( $weight == 'thin' or $weight == 'Thin' ) { $weight: 100; }\n  @else if ( $weight == 'extra light' or $weight == 'Extra light' or $weight == 'extra Light' or $weight == 'Extra Light' or  $weight == 'el') { $weight: 200; }\n  @else if ( $weight == 'light' or $weight == 'Light'  or $weight == 'l') { $weight: 300; }\n  @else if ( $weight == 'normal' or $weight == 'Normal'  or $weight == 'n') { $weight: 400; }\n  @else if ( $weight == 'medium' or $weight == 'Medium'  or $weight == 'm') { $weight: 500; }\n  @else if ( $weight == 'semi-bold' or $weight == 'Semi-bold' or $weight == 'semi-Bold' or $weight == 'Semi-Bold' or $weight == 'sb' ) { $weight: 600; }\n  @else if ( $weight == 'bold' or $weight == 'Bold' or $weight == 'b' ) { $weight: 700; }\n  @else if ( $weight == 'extra bold' or $weight == 'Extra bold' or $weight == 'extra Bold' or $weight == 'Extra Bold' or $weight == 'eb' ) { $weight: 800; }\n  @else if ( $weight == 'black' or $weight == 'Black' or $weight == 'blk') { $weight: 900; }\n\n  @if ( $style == 'Italic' or $style == 'i' ) { $style: italic; }\n  @else { $style: normal; }\n\n  font-family: $font-family;\n  font-size: $size;\n  font-weight: $weight;\n  font-style: $style;\n}\n","\n%flex-column            {\n                          display: flex;\n                          flex-direction: column;\n                        }\n\n%flex-row               {\n                          display: flex;\n                          flex-direction: row;\n                        }\n\n%flex-jCenter-aCenter   {\n                          justify-content: center;\n                          align-items: center;\n                        }\n\n%flex-jCenter-aStart    {\n                          justify-content: center;\n                          align-items: flex-start;\n                        }\n\n%flex-jCenter-aEnd      {\n                          justify-content: center;\n                          align-items: flex-end;\n                        }\n\n%flex-jStart-aCenter    {\n                          justify-content: flex-start;\n                          align-items: center;\n                        }\n\n%flex-jStart-aStart     {\n                          justify-content: flex-start;\n                          align-items: flex-start;\n                        }\n\n%flex-jStart-aEnd       {\n                          justify-content: flex-start;\n                          align-items: flex-end;\n                        }\n\n%flex-jEnd-aCenter      {\n                          justify-content: flex-end;\n                          align-items: center;\n                        }\n\n%flex-jEnd-aStart       {\n                          justify-content: flex-end;\n                          align-items: flex-start;\n                        }\n\n%flex-jEnd-aEnd         {\n                          justify-content: flex-end;\n                          align-items: flex-end;\n                        }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
